import { SearchItem } from "./types";

export const searchRegistry: SearchItem[] = [
  // ============ PAGES ============
  {
    id: "dashboard",
    title: "Dashboard",
    description: "View your dashboard overview",
    keywords: ["dashboard", "home", "overview", "main", "start"],
    category: "Pages",
    path: "/",
    icon: "home",
  },
  {
    id: "agents",
    title: "Agents",
    description: "Manage your AI agents",
    keywords: ["agents", "bots", "voice", "assistant", "list"],
    category: "Pages",
    path: "/agents",
    icon: "bot",
  },
  {
    id: "create-agent",
    title: "Create Agent",
    description: "Create a new AI agent",
    keywords: ["create", "new", "add", "build", "agent"],
    category: "Pages",
    path: "/agents/new",
    icon: "add",
  },
  {
    id: "simulations",
    title: "Simulations",
    description: "Run agent simulations",
    keywords: ["simulations", "test", "simulate", "run", "batch"],
    category: "Pages",
    path: "/agents/simulations",
    icon: "play",
    adminOnly: true,
  },
  {
    id: "create-simulation",
    title: "Create Simulation",
    description: "Create a new simulation",
    keywords: ["create", "new", "add", "simulation", "test"],
    category: "Pages",
    path: "/agents/simulations/new",
    icon: "add",
    adminOnly: true,
  },
  {
    id: "evaluators",
    title: "Evaluators",
    description: "Manage evaluators",
    keywords: ["evaluators", "test", "quality", "check", "score"],
    category: "Pages",
    path: "/evaluators",
    icon: "checklist",
    adminOnly: true,
  },
  {
    id: "create-evaluator",
    title: "Create Evaluator",
    description: "Create a new evaluator",
    keywords: ["create", "new", "add", "evaluator", "quality"],
    category: "Pages",
    path: "/evaluators/new",
    icon: "add",
    adminOnly: true,
  },
  {
    id: "organization",
    title: "Organization",
    description: "Organization settings and members",
    keywords: ["organization", "team", "company", "workspace", "settings"],
    category: "Pages",
    path: "/organization/members",
    icon: "users",
  },
  {
    id: "voice-library",
    title: "Voice Library",
    description: "Browse and manage voices",
    keywords: ["voice", "library", "voices", "audio", "speech", "tts", "text-to-speech"],
    category: "Pages",
    path: "/voice-library",
    icon: "voice-over",
  },
  {
    id: "stt-lab",
    title: "STT Lab",
    description: "Test and compare speech-to-text models",
    keywords: ["stt", "lab", "speech", "transcription", "transcribe", "voice", "recognition", "test", "compare", "models"],
    category: "Pages",
    path: "/sttlab",
    icon: "mic",
  },
  {
    id: "resources",
    title: "Resources / Documentation",
    description: "Documentation and resources",
    keywords: ["resources", "docs", "help", "guide", "documentation", "learn"],
    category: "Pages",
    path: "/resources",
    icon: "folder_open",
  },
  {
    id: "profile",
    title: "Profile",
    description: "Your account settings",
    keywords: ["profile", "account", "user", "settings", "me"],
    category: "Pages",
    path: "/profile",
    icon: "person",
  },
  {
    id: "notifications",
    title: "Notifications",
    description: "View your notifications",
    keywords: ["notifications", "alerts", "messages", "inbox"],
    category: "Pages",
    path: "/notifications",
    icon: "notification",
    adminOnly: true,
  },
  {
    id: "notification-preferences",
    title: "Notification Preferences",
    description: "Configure notification settings",
    keywords: ["notification", "preferences", "settings", "alerts", "email"],
    category: "Pages",
    path: "/notification-preferences",
    icon: "settings",
    adminOnly: true,
  },
  {
    id: "style-guide",
    title: "Style Guide",
    description: "Design system components",
    keywords: ["style", "guide", "design", "components", "ui", "styles"],
    category: "Pages",
    path: "/style-guide",
    icon: "brush",
    adminOnly: true,
  },
  {
    id: "admin-users",
    title: "Admin: Users",
    description: "Manage platform users",
    keywords: ["admin", "users", "manage", "accounts"],
    category: "Pages",
    path: "/admin/users",
    icon: "users",
    adminOnly: true,
  },
  {
    id: "admin-organizations",
    title: "Admin: Organizations",
    description: "Manage organizations",
    keywords: ["admin", "organizations", "orgs", "manage", "workspaces"],
    category: "Pages",
    path: "/admin/organizations",
    icon: "grid",
    adminOnly: true,
  },

  // ============ AGENT FEATURES (Tabs) ============
  {
    id: "agent-overview",
    title: "Agent Overview",
    description: "View agent details, analytics, and configuration",
    keywords: ["agent", "overview", "details", "info", "analytics", "metrics", "stats", "statistics", "charts", "data"],
    category: "Agent Features",
    path: "/agents/:agentId/overview",
    icon: "bot",
  },
  {
    id: "agent-function",
    title: "Agent Function",
    description: "Edit agent code and logic",
    keywords: ["agent", "function", "code", "editor", "logic", "script"],
    category: "Agent Features",
    path: "/agents/:agentId/function",
    icon: "code",
  },
  {
    id: "agent-environments",
    title: "Agent Environments",
    description: "Configure agent environments",
    keywords: ["agent", "environments", "env", "config", "variables", "settings"],
    category: "Agent Features",
    path: "/agents/:agentId/environments",
    icon: "layers",
  },
  {
    id: "agent-sessions",
    title: "Agent Sessions",
    description: "View conversation sessions and calls",
    keywords: ["agent", "sessions", "calls", "conversations", "history", "logs"],
    category: "Agent Features",
    path: "/agents/:agentId/sessions",
    icon: "message",
  },
  {
    id: "agent-deployments",
    title: "Agent Deployments",
    description: "Deploy agent to channels",
    keywords: ["agent", "deployments", "deploy", "publish", "channels", "release", "live"],
    category: "Agent Features",
    path: "/agents/:agentId/deployments",
    icon: "rocket",
  },
  {
    id: "agent-testing",
    title: "Agent Testing",
    description: "Test agent functionality",
    keywords: ["agent", "testing", "test", "debug", "try", "playground", "sandbox", "a/b testing", "ab testing", "ab"],
    category: "Agent Features",
    path: "/agents/:agentId/testing",
    icon: "testing",
  },
  {
    id: "agent-evaluation",
    title: "Agent Evaluation",
    description: "Evaluate agent performance",
    keywords: ["agent", "evaluation", "quality", "score", "metrics", "performance"],
    category: "Agent Features",
    path: "/agents/:agentId/evaluation",
    icon: "checklist",
  },

  {
    id: "agent-metrics",
    title: "Agent Custom Metrics",
    description: "View custom metrics and time-series charts for an agent",
    keywords: ["agent", "metrics", "custom", "prometheus", "charts", "timeseries", "monitoring", "dashboard"],
    category: "Agent Features",
    path: "/agents/:agentId/metrics",
    icon: "activity",
  },

  // ============ AGENT SETTINGS (Dialogs) ============
  {
    id: "webhooks",
    title: "Webhooks",
    description: "Configure webhooks for agent environments",
    keywords: ["webhooks", "webhook", "http", "callback", "integration", "api", "events"],
    category: "Agent Settings",
    path: "/agents/:agentId/environments?openModal=webhook",
    icon: "link",
  },
  {
    id: "startup-settings",
    title: "Startup Settings",
    description: "Configure initial agent behavior",
    keywords: ["startup", "settings", "greeting", "init", "initial", "welcome", "connection timeout", "startup audio snippet", "interruptible", "recording"],
    category: "Agent Settings",
    path: "/agents/:agentId/environments?openModal=startup",
    icon: "zap",
  },
  {
    id: "error-fallback",
    title: "Error Fallback Settings",
    description: "Configure error handling and failover",
    keywords: ["error", "fallback", "failover", "recovery", "failure"],
    category: "Agent Settings",
    path: "/agents/:agentId/environments?openModal=fallback",
    icon: "error",
  },
  {
    id: "privacy-settings",
    title: "Privacy Settings",
    description: "Configure PII redaction and privacy",
    keywords: ["privacy", "settings", "pii", "redaction", "gdpr", "data", "tracing", "traces"],
    category: "Agent Settings",
    path: "/agents/:agentId/environments?openModal=privacy",
    icon: "shield",
  },
  {
    id: "stt-settings",
    title: "STT Settings",
    description: "Configure speech-to-text settings",
    keywords: [
      "stt",
      "settings",
      "speech",
      "transcription",
      "voice",
      "recognition",
      "model",
      "endpointing",
      "audio input delay",
      "input delay",
      "stt language",
      "language",
      "auto switch",
      "stt auto switch",
      "prewarm",
      "stt filter",
      "stt keywords",
      "eot",
      "vad",
      "noise reduction",
    ],
    category: "Agent Settings",
    path: "/agents/:agentId/environments?openModal=stt",
    icon: "mic",
  },
  {
    id: "region-settings",
    title: "Region Settings",
    description: "Configure region-specific settings",
    keywords: ["region", "settings", "location", "data center", "server"],
    category: "Agent Settings",
    path: "/agents/:agentId/environments?openModal=region",
    icon: "language",
  },

  // ============ ORGANIZATION FEATURES ============
  {
    id: "organization-settings",
    title: "Organization Settings",
    description: "Edit organization name and view current plan",
    keywords: ["organization", "name", "rename", "plan", "tier", "enterprise", "upgrade", "settings"],
    category: "Organization",
    path: "/organization/configurations#organization",
    icon: "settings",
  },
  {
    id: "api-keys",
    title: "API Keys",
    description: "Manage your API keys",
    keywords: ["api", "keys", "tokens", "authentication", "access"],
    category: "Organization",
    path: "/organization/configurations#global-variables",
    icon: "key",
  },
  {
    id: "team-members",
    title: "Team Members",
    description: "View and manage team members",
    keywords: ["team", "members", "users", "people", "colleagues"],
    category: "Organization",
    path: "/organization/members",
    icon: "users",
  },
  {
    id: "invite-members",
    title: "Invite Members",
    description: "Invite new team members",
    keywords: ["invite", "members", "add", "team", "new"],
    category: "Organization",
    path: "/organization/members",
    icon: "invite",
  },
  {
    id: "telephony-settings",
    title: "Telephony Settings",
    description: "Configure Twilio and Telnyx",
    keywords: ["telephony", "phone", "twilio", "telnyx", "calling", "sip"],
    category: "Organization",
    path: "/organization/configurations#telephony-configurations",
    icon: "phone",
  },
  {
    id: "global-variables",
    title: "Global Variables",
    description: "Manage organization environment variables",
    keywords: ["global", "variables", "env", "environment", "config", "secrets"],
    category: "Organization",
    path: "/organization/configurations#global-variables",
    icon: "list",
  },
  {
    id: "custom-voices",
    title: "Custom Voices",
    description: "Manage custom voice clones",
    keywords: ["custom", "voices", "voice", "clone", "tts", "audio"],
    category: "Organization",
    path: "/organization/configurations#custom-voices",
    icon: "voice-over",
  },
  {
    id: "snippets",
    title: "Snippets",
    description: "Manage reusable code snippets",
    keywords: ["snippets", "code", "reusable", "templates", "blocks"],
    category: "Organization",
    path: "/organization/configurations#audio-snippets",
    icon: "snippet",
  },
  {
    id: "usage-billing",
    title: "Usage & Billing",
    description: "View usage statistics and billing",
    keywords: ["usage", "billing", "cost", "payment", "invoice"],
    category: "Organization",
    path: "/organization/usage",
    icon: "activity",
  },
  {
    id: "credits-billing",
    title: "Billing & Credits",
    description: "View credit balance and add funds",
    keywords: ["credits", "billing", "balance", "funds", "payment", "transactions"],
    category: "Organization",
    path: "/organization/billing",
    icon: "payments",
  },
];
